import { Button, Dropdown, Space, Menu, Layout, Avatar, Drawer } from 'antd'
import { useAuthStore } from 'src/store/auth'
import {
  SettingOutlined,
  LogoutOutlined,
  MenuOutlined
} from '@ant-design/icons'
import { useState, useEffect } from 'react'

import './AppLayout.css'
import { Link } from 'react-router-dom'

const { Header } = Layout

export const AppHeader = () => {
  const {
    user,
    logoutUser,
    mainMenu,
    activeKeyMainMenu,
    setActiveKeyMainMenu
  } = useAuthStore((store) => store)

  const [open, setOpen] = useState(false)

  const items = [
    {
      key: '2',
      label: (
        <Button className='header-dropdown-item' onClick={logoutUser}>
          <LogoutOutlined /> Logout
        </Button>
      )
    }
  ]

  const handleSelect = (item) => {
    setActiveKeyMainMenu(item?.key)
  }

  return (
    <Header className='layout-header__wrapper'>
      <Link className='logo' to='/administrator'>
        PICnFIND
      </Link>
      <div className='menu-wrapper'>
        {mainMenu ? (
          <Menu
            selectedKeys={[activeKeyMainMenu]}
            className='menu'
            theme='light'
            mode='horizontal'
            items={mainMenu}
            onSelect={handleSelect}
          />
        ) : null}
        {mainMenu ? (
          <>
            <Button
              type='text'
              className='mobile-menu'
              onClick={() => setOpen(true)}
            >
              <MenuOutlined />
            </Button>
            <Drawer
              title='Main menu'
              placement='left'
              onClose={() => setOpen(false)}
              open={open}
            >
              <Menu
                selectedKeys={[activeKeyMainMenu]}
                theme='light'
                items={mainMenu}
                onSelect={handleSelect}
              />
            </Drawer>
          </>
        ) : null}
        {user ? (
          <Dropdown
            overlayClassName='avatar-block'
            menu={{ items }}
            placement='bottomRight'
          >
            <Space wrap size={8}>
              <div className='avatar-block-name'>
                <p className='name'>{user?.name}</p>
              </div>
            </Space>
          </Dropdown>
        ) : (
          <Space wrap size={16}>
            <Link to='/administrator/sign-in'>
              <Button type='primary'>Sign In</Button>
            </Link>
          </Space>
        )}
      </div>
    </Header>
  )
}
